import React from 'react'
import { Box, Typography } from '@mui/material'

const Header = ({ background, text }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '40vh', sm: '50vh', md: '60vh' },
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Dark overlay (same as carousel) */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.45)',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          maxWidth: '800px',
          px: 2,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: 'white',
            fontWeight: 700,
            textShadow: '0 2px 8px rgba(0,0,0,0.6)',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  )
}

export default Header